module.exports = __webpack_public_path__ + "img/fgdj-bg.25cafe7c.png";